var TEXT_CLICK = 'TEXT_CLICK';
var ACTION_TYPES = {
  TEXT_CLICK: TEXT_CLICK
};
export default ACTION_TYPES;